// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"styles_gridContainer__3Txun"};